import React from "react";
import { DomainStats } from "utils/analytics/types";

interface DomainDetailsPanelProps {
  loading: boolean;
  stats: DomainStats | null;
  error?: boolean;
  DomainDetails: React.ComponentType<{ details: DomainStats }>;
}

const DomainDetailsPanel: React.FC<DomainDetailsPanelProps> = ({
  loading,
  stats,
  error,
  DomainDetails,
}) => {
  return (
    <div className="bg-[#fafbfc]">
      {loading ? (
        <div className="py-8 text-center text-gray-500">Loading details...</div>
      ) : stats ? (
        <DomainDetails details={stats} />
      ) : error ? (
        <div className="py-8 text-center text-gray-500">
          Failed to load details — close and reopen this row to retry.
        </div>
      ) : (
        <div className="py-8 text-center text-gray-500">
          No details available
        </div>
      )}
    </div>
  );
};

export default DomainDetailsPanel;
